export default "__VITE_ASSET__DQqp3SAo__"